import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgMessanger({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3c-4.97 0-9 3.73-9 8.331 0 2.618 1.304 4.953 3.344 6.48V21l3.07-1.686a9.672 9.672 0 002.586.348c4.97 0 9-3.73 9-8.33C21 6.73 16.97 3 12 3zm.948 11.172l-2.328-2.394-4.483 2.454 4.915-5.163 2.328 2.394 4.482-2.454-4.914 5.163z"
        fill={color}
      />
    </svg>
  )
}

export default SvgMessanger
